<template>
  <div class="private_container">
    <div class="tabs">
      <el-tabs v-model="activeName"
               @tab-click="handleClick"
               class="tabsComtainer">
        <el-tab-pane label="全部运单"
                     name="-1"></el-tab-pane>
        <el-tab-pane label="待运输"
                     name="1"></el-tab-pane>
        <el-tab-pane label="运输中"
                     name="2"></el-tab-pane>
        <el-tab-pane label="运输完成"
                     name="3"></el-tab-pane>
      </el-tabs>
      <div class="tabsSelect">
        <el-input placeholder="请输入原料名称"
                  size="small"
                  v-model="searchInput"
                  class="input-with-select">
          <el-select v-model="waybillSelect"
                     slot="prepend"
                     placeholder="普通搜索">
            <el-option label="普通搜索"
                       value="1"></el-option>
            <el-option label="高级搜索"
                       value="2"></el-option>
          </el-select>
          <el-button slot="append"
                     icon="el-icon-search"
                     @click="handleSearchClick"></el-button>
        </el-input>
      </div>
    </div>
    <div class="search"
         v-show="waybillSelect === '2'">
      <el-form class="search-form-inline">
        <el-form-item label="出发地">
          <el-cascader size="small"
                       class="addressStyle"
                       @active-item-change="handleItemChange"
                       :options="options"
                       v-model="addressFrom"
                       @change="handleChangeFrom">
          </el-cascader>
        </el-form-item>
        <el-form-item label="目的地">
          <el-cascader size="small"
                       class="addressStyle"
                       :options="options"
                       v-model="addressTo"
                       @active-item-change="handleItemChange"
                       @change="handleChangeTo">
          </el-cascader>
        </el-form-item>
        <el-form-item label="货主公司">
          <el-input v-model="companyName"
                    placeholder="请输入货主公司名称"
                    size="small"></el-input>
        </el-form-item>
        <el-form-item label="货源编号">
          <el-input v-model="goodsNo"
                    placeholder="请输入货源编号名称"
                    size="small"></el-input>
        </el-form-item>
      </el-form>
      <div class="searchBtn">
        <el-button size="small"
                   @click="handleSeniorSearchClick">查询</el-button>
        <el-button size="small"
                   @click='handleCancelSearchClick'>
          清除条件
        </el-button>
      </div>
    </div>
    <div v-bind:class="waybillSelect === '2'?'special-container isactive':'special-container'">
      <el-table :data="data.result"
                style="width: 100%"
                height="100%">
        <el-table-column class-name="number"
                         label="序号"
                         align="center"
                         type="index"
                         min-width="40"
                         fixed>
        </el-table-column>
        <el-table-column class-name="sourceNumber"
                         prop="goodsNo"
                         label="货源编号">
        </el-table-column>
        <el-table-column label="货主公司">
          <template slot-scope="scope">
            <div>{{scope.row.companyName}}</div>
          </template>
        </el-table-column>
        <el-table-column label="炼厂名称">
          <template slot-scope="scope">
            <div>{{scope.row.factoryName}}</div>
          </template>
        </el-table-column>
        <el-table-column label="位置信息">
          <template slot-scope="scope">
            <div><span>出发地：</span>{{scope.row.departureName}}{{scope.row.departureAddress}}</div>
            <div><span>目的地：</span>{{scope.row.destinationName}}{{scope.row.destinationAddress}}</div>
          </template>
        </el-table-column>
        <el-table-column label="货源信息">
          <template slot-scope="scope">
            <div><span>原料：</span>{{scope.row.material}}</div>
            <div><span>重量：</span>{{scope.row.totalWeight}}吨</div>
          </template>
        </el-table-column>
        <el-table-column label="状态"
                         header-align="center"
                         align="center"
                         width="80">
          <template slot-scope="scope">
            <div v-if="scope.row.transportStatus  === 1"
                 class="status-style wating">待运输</div>
            <div v-else-if="scope.row.transportStatus  === 2"
                 class="status-style progress">运输中</div>
            <div v-else-if="scope.row.transportStatus  === 3"
                 class="status-style complated">运输完成</div>
            <div v-else-if="scope.row.transportStatus  === 0"
                 class="status-style wating">待匹配</div>
          </template>
        </el-table-column>
        <el-table-column header-align="center"
                         label="操作"
                         align="center">
          <template slot-scope="scope">
            <el-button plain
                       class="btnc"
                       @click="handleWaybillClick(scope.row.id)">运单详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="pages">
        <span class="demonstartion"> 共{{data.total}}条记录</span>
        <el-pagination @current-change="handleCurrentChange"
                       :page-size="data.pageSize"
                       layout="prev, pager, next"
                       :total="data.total"
                       background>
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getPrivateWaybill,
  provinceList,
  cityList,
  areaList
} from 'apis/index'
export default {
  name: 'Container',
  data () {
    return {
      data: {},
      input: '',
      activeName: '-1',
      searchInput: '',
      waybillSelect: '',
      options: [],
      addressFrom: [],
      addressTo: [],
      from: '',
      to: '',
      address: '',
      companyName: '',
      goodsNo: '',
      pageNum: 1
    }
  },
  methods: {
    async initData () { // 省市区三级联动
      let ret = await provinceList()
      if (ret.data.code === 0) {
        let newData = JSON.stringify(ret.data.data.result)
        newData = newData.replace(/provinceCode/g, 'value')
        newData = newData.replace(/provinceName/g, 'label')
        this.options = JSON.parse(newData)
        this.options.forEach((item, index) => {
          this.$set(this.options[index], 'children', [])
        })
        // console.log('11')
      }
    },
    async handleItemChange (val) {
      // console.log('active item:', val)
      // console.log(val)
      if (val.length === 1) { // 请求省，且只第一次才发请求
        let provinceCode = val[0]
        for (let j = 0; j < this.options.length; j++) {
          if (this.options[j].value === provinceCode && !this.options[j].children.length) {
            let ret = await cityList({ provinceCode })
            if (ret.data.code === 0) {
              let newData = JSON.stringify(ret.data.data.result)
              newData = newData.replace(/cityCode/g, 'value')
              newData = newData.replace(/cityName/g, 'label')
              let newCity = JSON.parse(newData)
              newCity.forEach(item => {
                item.children = []
              })
              this.$set(this.options[j], 'children', newCity)
              break
            }
          }
        }
      }
      if (val.length === 2) { // 请求市区，且只第一次才发请求
        let provinceCode = val[0]
        let cityCode = val[1]
        for (let j = 0; j < this.options.length; j++) {
          if (this.options[j].value === provinceCode && this.options[j].children.length) {
            for (let k = 0; k < this.options[j].children.length; k++) {
              if (this.options[j].children[k].value === cityCode && !this.options[j].children[k].children.length) {
                let ret = await areaList({ cityCode })
                if (ret.data.code === 0) {
                  if (!ret.data.data.result.length) { // 修复中山市/东莞市等三级为空数组的情况
                    let newArea = [{
                      value: this.options[j].children[k].value,
                      label: this.options[j].children[k].label
                    }]
                    this.$set(this.options[j].children[k], 'children', newArea)
                    break
                  }
                  let newData = JSON.stringify(ret.data.data.result)
                  newData = newData.replace(/areaCode/g, 'value')
                  newData = newData.replace(/areaName/g, 'label')
                  let newArea = JSON.parse(newData)
                  this.$set(this.options[j].children[k], 'children', newArea)
                  break
                }
              }
            }
          }
        }
      }
    },
    getAddressText (value) { // 获取地址
      for (var i = 0; i < this.options.length; i++) {
        if (this.options[i].value === value[0]) {
          this.address = this.options[i].label
          let city = this.options[i].children
          for (var j = 0; j < city.length; j++) {
            if (city[j].value === value[1]) {
              this.address += ',' + city[j].label
              let area = city[j].children
              for (var k = 0; k < area.length; k++) {
                if (area[k].value === value[2]) {
                  this.address += ',' + area[k].label
                }
              }
            }
          }
        }
      }
    },
    handleChangeFrom (value) {
      this.getAddressText(value)
      this.from = this.address
      // console.log(this.from + 'dsafsd')
    },
    handleChangeTo (value) {
      this.getAddressText(value)
      this.to = this.address
      // console.log(this.to)
    },
    handleCancelSearchClick () { // 清除查询条件
      this.searchInput = ''
      this.addressFrom = []
      this.addressTo = []
      this.companyName = ''
      this.goodsNo = ''
      this.address = ''
      this.from = ''
      this.to = ''
      this.getData()
    },
    handleClick () { // 运单状态切换
      // let orderState = this.activeName === '-1' ? '' : this.activeName
      this.handleCancelSearchClick()
      // this.getData()
    },

    getData () { // 初始化
      getPrivateWaybill({
        pageNum: this.pageNum,
        departureName: this.from,
        destinationName: this.to,
        goodsNo: this.goodsNo,
        companyName: this.companyName,
        material: this.searchInput,
        status: this.activeName === '-1' ? '' : this.activeName

      }).then(res => {
        console.log('sss', res)
        if (res.data.code === 0) {
          this.data = res.data.data.result
        }
      })
    },
    handleSearchClick () { // 简单查询
      console.log(this.searchInput)
      this.getData()
    },
    handleSeniorSearchClick () { // 高级搜索
      this.getData()
    },
    handleWaybillClick (id) { // 运单详情
      this.$router.push({ path: 'privateWaybill/privateDetail', query: { item: id } })
    },
    handleCurrentChange (val) { // 切页切换
      this.pageNum = val
      this.getData()
    }
  },
  mounted () {
    this.getData()
    this.initData()
  }
}
</script>

<style lang="stylus">
@import '~styles/mixins.styl'
.private_container
  height 100%
  .tabs
    width 100%
    height 50px
    overflow hidden
    border-bottom 1px solid #ccc
    .el-tabs__nav-wrap::after
      height 1px
      bottom 1px solid transparent
    .el-tabs__item
      padding 0
      text-align center
      height 51px
      line-height 50px
      width 92px
      size12()
      color #5e656f
    .el-tabs__item.is-active
      border-bottom 2px solid #409EFF
      color #1b88ee
    .el-tabs__active-bar
      background transparent !important
    .el-tabs
      float left
    .tabsSelect
      float right
      margin-right 20px
      margin-top 5px
      .el-select .el-input
        width 110px
      .input-with-select .el-input-group__prepend
        background #fff
  .search
    overflow hidden
    .search-form-inline
      width calc(100% - 160px)
      float left
      margin-top 5px
      .el-form-item
        display inline-block
        margin-bottom 0
        label
          width 97px
        .el-form-item__content
          width 146px
          float left
        .company-name
          width 146px
          padding 0
          margin 0
        .search-submit
          padding 5px 20px
          background #fff
          text-align right
          color $bgColor
          size12()
          &:hover
            background $bgColor
            color #fff
        .addressStyle
          width 146px
          line-height 30px
    .searchBtn
      width 80px
      float right
      margin-right 20px
      .el-button
        width 78px
        margin 12px 0 0
        padding 7px 15px
  .special-container
    margin-left 20px
    margin-top 10px
    margin-right 20px
    height calc(100% - 112px)
    .el-table
      background #f7f9fb
    .el-table th
      background #e7f0f8
    .el-table td div
      size12()
    .el-table th>.cell
      size12()
    .status-style
      width 40px
      height 40px
      border-radius 50%
      border 1px solid transparent
      size10()
      line-height 40px
      text-align center
    .wating
      wating()
    .progress
      progress()
    .complated
      complated()
    .failure
      failure()
      size10()
    .el-button
      size12()
      margin-bottom 10px
      margin-left 10px
    .btnc
      btnc()
  .isactive
    height calc(100% - 192px)
  .pages
    margin 15px 20px 0
    // margin-bottom 15px
    .demonstartion
      float right
      line-height 30px
      color #5e656f
  .el-table td, .el-table th
    vertical-align top
</style>
